import { loadQuery, PreloadedQuery } from 'react-relay';

import { getRelayEnvironment } from '@townsquare/relay-utils/townsquare-environment';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { createSearchParamsFromCurrentUrl } from '@townsquare/search-params';

import { routes } from '../router/routes';

import BootstrapQuery, {
	BootstrapQuery$variables,
	type BootstrapQuery as BootstrapQueryType,
} from './__generated__/BootstrapQuery.graphql';

export const preloadQueryRef = (): PreloadedQuery<BootstrapQueryType> => {
	const urlSearch = Object.fromEntries(createSearchParamsFromCurrentUrl());
	const matchedRoute = matchRoute(routes, window.location.pathname, urlSearch);
	const context: NonNullable<BootstrapQuery$variables['context']> = {
		orgId: matchedRoute?.match.params.orgIdentifier,
		cloudId: matchedRoute?.match.params.siteIdentifier || urlSearch.cloudId,
	};

	const contextExists = context.orgId || context.cloudId;

	const RelayEnvironment = getRelayEnvironment();

	return loadQuery<BootstrapQueryType>(
		RelayEnvironment,
		BootstrapQuery,
		contextExists ? { context } : {},
	);
};
